import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addParenthesis',
    standalone: false
})
export class AddParenthesisPipe implements PipeTransform {
  transform(value: string | null, features: any): unknown {
    if (value && value !== '$0') {
      const hasNegativeSign = value.charAt(0) === '-';
      return !hasNegativeSign
        ? `(${value})`
        : value?.substring(1, value?.length);
    }
    return value;
  }
}
